export interface ILanguage {
  id?: string,
  languageCode: string,
  proficiencyLevel: number,
  // proficiencyLevelDescription?: PROFICIENCY_DESCRIPTIONS,
}

export enum PROFICIENCY_DESCRIPTIONS {
  NO_PROFICIENCY = 'NO_PROFICIENCY',
  ELEMENTARY_WORKING = 'ELEMENTARY_WORKING',
  LIMITED_WORKING = 'LIMITED_WORKING',
  PROFESSIONAL_WORKING = 'PROFESSIONAL_WORKING',
  FULL_PROFESSIONAL_WORKING = 'FULL_PROFESSIONAL_WORKING',
  NATIVE = 'NATIVE'
}

export const PROFICIENCY_MAP = {
  [PROFICIENCY_DESCRIPTIONS.NO_PROFICIENCY]: 'No Proficiency',
  [PROFICIENCY_DESCRIPTIONS.ELEMENTARY_WORKING]: 'Elementary Proficiency',
  [PROFICIENCY_DESCRIPTIONS.LIMITED_WORKING]: 'Limited Working Proficiency',
  [PROFICIENCY_DESCRIPTIONS.PROFESSIONAL_WORKING]: 'Professional Working Proficiency',
  [PROFICIENCY_DESCRIPTIONS.FULL_PROFESSIONAL_WORKING]: 'Full Professional Proficiency',
  [PROFICIENCY_DESCRIPTIONS.NATIVE]: 'Native / Bilingual Proficiency'
};

export const getProficiencyByNumber = (level: number) => PROFICIENCY_MAP[Object.values(PROFICIENCY_DESCRIPTIONS)[level - 1]];